<template>
  <div>
    <form @submit.prevent="updateExtension">
      <div class="va-row">
        <div class="flex md12 xs12">
          <div class="form-group">
            <div class="input-group required">
              <input
                type="email"
                id="email"
                name="email"
                readonly
                v-model="modExtension.email"
              />
              <label class="control-label" for="email">Email</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="va-row">
        <div class="flex md12 xs12">
          <div class="form-group">
            <div class="input-group required">
              <input
                type="text"
                id="password"
                name="password"
                required
                autocomplete="off"
                v-model="modExtension.password"
              />
              <label class="control-label" for="password">Password</label>
              <i class="bar"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align--center justify--center down-container">
        <button class="btn btn-primary">
          <i class="fa fa-save"></i>
          Update
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mkdir } from 'fs'
export default {
  name: 'EditModal',
  props: {
    extension: {
      type: Object,
      required: true
    },
    modal: {
      type: Object
    }
  },
  computed: {
    modExtension() {
      return { ...this.extension }
    }
  },
  methods: {
    async updateExtension() {
      this.modal.close()
      const response = await this.$store.dispatch(
        'updateExtension',
        this.modExtension
      )
      if (response.success) {
        this.$toasted.show(response.data.message, {
          icon: 'fa-check-circle',
          position: 'top-right',
          duration: 5000,
          fullWidth: false
        })
      }
    }
  }
}
</script>
